import { forwardRef } from 'react';
import { classes } from 'utils/style';
import styles from './Text.module.css';

export const Text = forwardRef(
  (
    {
      children,
      size = 'm',
      as: Component = 'span',
      align = 'auto',
      weight = 'auto',
      secondary,
      className,
      ...rest
    },
    ref
  ) => {
    return (
      <Component
        ref={ref}
        className={classes(styles.text, className)}
        data-align={align}
        data-size={size}
        data-weight={weight}
        data-secondary={secondary}
        {...rest}
      >
        {children}
      </Component>
    );
  }
);

Text.displayName = 'Text';
